import "./App.css";
import Button from "@mui/material/Button";
import MainPage from "./pages/MainPage";
import PersonalPage from "./pages/PersonalPage";
import Login from "./pages/LoginPage";
import RegPage from "./pages/RegPage";
import ResetPage from "./pages/ResetPage";
import Oferta from "./pages/Oferta";
import { Routes, Route, Link, Outlet, Navigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import LogoutIcon from "@mui/icons-material/Logout";
import { userSlice } from "./redux/user/userSlice";
import PrivateRoute from "./components/PrivateRoute";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import { Tooltip } from "@mui/material";
import Confidencial from "./pages/Confidencial";

const { exitHandle, resetSelectedProject } = userSlice;

function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<MainPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/registration" element={<RegPage />} />
        <Route path="/reset" element={<ResetPage />} />
        <Route path="/reset-password/*" element={<ResetPage />} />
        <Route path="/oferta" element={<Oferta />} />
        <Route path="/politic-confidencial" element={<Confidencial />} />
        <Route
          path="/main/*"
          element={
            <PrivateRoute>
              <PersonalPage />
            </PrivateRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" />} />
      </Route>
    </Routes>
  );
}

function Layout() {
  const dispatch = useDispatch();
  const login = useSelector((state) => state.user?.data?.user?.login);

  const telegramUsername = "/MoGame_Support";
  const telegramLink = `https://t.me/${telegramUsername}`;

  return (
    <div>
      <header className="header">
        <div style={{ maxWidth: "200px", width: "100%", textAlign: "center" }}>
          <Link
            to={login ? "/main" : "/"}
            onClick={() => dispatch(resetSelectedProject())}
            style={{ textDecoration: "none" }}
          >
            <span
              style={{
                cursor: "pointer",
                color: "white",
                fontWeight: "bolder",
                fontSize: "18px",
              }}
            >
              MOGAME
            </span>
          </Link>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginRight: "20px",
          }}
        >
          {login ? (
            <div style={{ display: "flex", gap: "15px", alignItems: "center" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Tooltip title="Написать в поддержку" placement="left">
                  <div className="support">
                    <a
                      href={telegramLink}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <SupportAgentIcon sx={{ color: "white" }} />
                    </a>
                  </div>
                </Tooltip>
              </div>
              <div
                style={{
                  color: "white",
                  fontWeight: "bold",
                  fontSize: "16px",
                  borderBottom: "1px solid white",
                }}
              >
                <Link
                  to={"/main/profile"}
                  onClick={() => dispatch(resetSelectedProject())}
                  style={{ textDecoration: "none", color: "white" }}
                >
                  {login}
                </Link>
              </div>
              <LogoutIcon
                sx={{ cursor: "pointer", color: "white" }}
                onClick={() => dispatch(exitHandle())}
              />
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                gap: "10px",
              }}
            >
              <Tooltip title="Написать в поддержку" placement="left">
                <div className="support">
                  <a
                    href={telegramLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <SupportAgentIcon sx={{ color: "white" }} />
                  </a>
                </div>
              </Tooltip>
              <Link to={"/login"}>
                <Button
                  sx={{ bgcolor: "white" }}
                  variant="outlined"
                  size="small"
                >
                  Войти
                </Button>
              </Link>
              <Link to={"/registration"}>
                <Button
                  sx={{ bgcolor: "white" }}
                  variant="outlined"
                  size="small"
                >
                  Регистрация
                </Button>
              </Link>
            </div>
          )}
        </div>
      </header>

      <Outlet />
    </div>
  );
}

export default App;
